// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Posts from "./pages/Posts";
import Sim from "./pages/Sim";
import Apps from "./pages/Apps";
import About from "./pages/About";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Support from "./pages/Support";
import PaedsPrescribingPro from "./pages/PaedsPrescribingPro";
import PostDetail from "./pages/PostDetail";
import "./styles/theme.css";

function App() {
  return (
    <Router>
      <div className="App">
        <NavBar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/posts" element={<Posts />} />
          <Route path="/posts/:id" element={<PostDetail />} /> {/* Dynamic Route */}
          <Route path="/sim" element={<Sim />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/support" element={<Support />} />
          <Route path="/paeds-prescribing-pro" element={<PaedsPrescribingPro />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;